import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { ISettings } from '@lsq-frontend/angular-shared/settings';
import { Environment } from '@lsq-frontend/remote-services/enterprise/common';

@Injectable()
export class EnvironmentsGuard implements CanActivate {
    constructor(@Inject(SETTINGS) private _settings: ISettings) {}

    public canActivate(routeSnapshot: ActivatedRouteSnapshot): boolean {
        return (
            !routeSnapshot.data.environments ||
            !routeSnapshot.data.environments.length ||
            routeSnapshot.data.environments.some(
                (environment: Environment) => environment === this._settings.environment
            )
        );
    }
}
